import { render } from "./BusinessProtectionPolicyDetails.vue?vue&type=template&id=7ecc30fc&scoped=true"
import script from "./BusinessProtectionPolicyDetails.vue?vue&type=script&lang=js"
export * from "./BusinessProtectionPolicyDetails.vue?vue&type=script&lang=js"

import "./BusinessProtectionPolicyDetails.vue?vue&type=style&index=0&id=7ecc30fc&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecc30fc"]])

export default __exports__